import { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';
import { SelectMenu, SelectMenuOption } from '../../Atoms/SelectMenu';

// Build-time gate keyed off the per-environment REACT_APP_DATADOG_ENV (baked in
// at build time, so Vite's `define` substitution folds this to a constant and
// dead-code eliminates the simulator from the production bundle). Fail-closed:
// enabled ONLY for explicitly non-production envs, so no unexpected/blank value
// can ever turn it on in prod.
const DOCS_ENV = process.env.REACT_APP_DATADOG_ENV;
export const DOCS_ROLE_SIM_ENABLED = DOCS_ENV === 'dev' || DOCS_ENV === 'qa' || DOCS_ENV === 'local';

// The values the API's `simulate_role` param accepts: the six nav-role slugs, and
// `client` for what a client reads. The empty value clears simulation and falls back
// to the viewer's real roles.
const ROLE_OPTIONS: SelectMenuOption[] = [
  { value: '', text: 'My roles (no simulation)' },
  { value: 'admin', text: 'Admin' },
  { value: 'support', text: 'Support' },
  { value: 'executive', text: 'Executive' },
  { value: 'advisor', text: 'Advisor' },
  { value: 'csm', text: 'CSM' },
  { value: 'sdm', text: 'SDM' },
  { value: 'client', text: 'Client' }
];

interface DocsRoleSimulatorProps {
  value: string;
  onChange: (role: string) => void;
}

// Non-production affordance for previewing the docs as any single role without a
// second account. Callers must gate rendering on DOCS_ROLE_SIM_ENABLED so this
// never appears in production.
const SELECT_ID = 'docs-simulate-role';

export const DocsRoleSimulator: FunctionComponent<DocsRoleSimulatorProps> = ({ value, onChange }) => (
  <Box sx={{ px: 2, pb: 1.5 }}>
    <Typography
      component="label"
      htmlFor={SELECT_ID}
      variant="caption"
      sx={{ display: 'block', mb: 0.5, color: 'text.secondary', fontWeight: 600 }}>
      Preview as role (non-prod only)
    </Typography>
    <SelectMenu
      id={SELECT_ID}
      name={SELECT_ID}
      dataCy={SELECT_ID}
      value={value}
      handleSelect={(e) => onChange(e.target.value)}
      options={ROLE_OPTIONS}
      selectClasses="text-xs"
    />
  </Box>
);
